import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { createProject } from '@/features/projects/create-project/api/create-project';
import { CreateProjectStoreData } from '@/features/projects/create-project/store/use-create-project-store';
import { getDeeplinkPrefix } from '@/shared/utils/deeplink-prefix';

type CreateProjectProps = Omit<
  UseMutationOptions<
    {
      projectId: number;
    },
    unknown,
    {
      org_id: number;
      data: CreateProjectStoreData;
    }
  >,
  'mutationFn'
>;

export const useCreateProjectMutation = ({ ...props }: CreateProjectProps) => {
  return useMutation({
    ...props,
    mutationFn: async ({ data, org_id }) => {
      const kpis = data.kpis ?? [];
      const memberIdsToInvite = data.memberIdsToInvite ?? [];

      const deeplinkPrefix = getDeeplinkPrefix();

      const result = await createProject({
        name: data.projectName,
        category: data.selectedCategory,
        description: data.projectDescription,
        start_date: data.date?.from?.toISOString(),
        end_date: data.date?.to?.toISOString(),
        status: 'active',
        kpis: kpis.map((kpi) => ({
          name: kpi.name,
          max_value: kpi.max_value ? kpi.max_value : undefined,
          description: undefined,
          type: kpi.type,
          unit: kpi.unit,
        })),
        member_invites: memberIdsToInvite.map((memberId) => ({
          org_member_id: memberId,
          deeplink_prefix: deeplinkPrefix,
        })),
        org_id,
      });

      return { projectId: result };
    },
  });
};
